import React from "react";
import classNames from "classnames";
import {formatPureAttributes} from "./index";
import Button from "../../Button";

export const ListNode = (Tag, props) => {
    return <Tag {...formatPureAttributes(props.node.data.get('attributes'))} className={classNames(props.className)}>{props.children}</Tag>;
}

const isUl = (value) => value.blocks.find((block) => block.type + "" === 'ul');
const isOl = (value) => value.blocks.find((block) => block.type + "" === 'ol');

export class ListEdit extends React.Component {
    render() {
        return (
            <div className="lists">
                <Button
                    disabled={this.props.disabled}
                    icon="format_list_bulleted"
                    color={isUl(this.props.value) ? "primary" : "default"} tooltip="Lista"
                    onClick={(e) => {
                        e && e.preventDefault();
                        let editor = null;
                        if (!isUl(this.props.value)) {
                            editor = this.props.editor
                                .setBlocks({type: 'ul', data: {tagname}})
                                .focus();
                        } else {
                            editor = this.props.editor
                                //.unwrapNodeByKey(node.key)
                                .setBlocks('paragraph')
                                .focus();
                        }
                        this.props.saveEditing && this.props.saveEditing(editor);
                    }}/>
                <Button
                    disabled={this.props.disabled}
                    icon="format_list_numbered"
                    color={isOl(this.props.value) ? "primary" : "default"} tooltip="Számozott lista"
                    onClick={(e) => {
                        e && e.preventDefault();
                        let editor = null;
                        if (!isOl(this.props.value)) {
                            editor = this.props.editor
                                .setBlocks({type: 'ol', data: {tagname}})
                                .focus();
                        } else {
                            editor = this.props.editor
                                //.unwrapNodeByKey(node.key)
                                .setBlocks('paragraph')
                                .focus();
                        }
                        this.props.saveEditing && this.props.saveEditing(editor);
                    }}/>
            </div>
        );
    }
}